module.exports = __webpack_public_path__ + "static/img/pk.f0eea274.svg";